module.exports = __webpack_public_path__ + "static/img/algo-img-1.3095bf4.3095bf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/algo-img-1.3095bf4.jpg
// module id = E38O
// module chunks = 2